///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { API } from "./axios";
import { datRatesMockData } from "../__mock__/datRatesMock";

const isMockDatRatesEnabled = () => {
  const windowFlag =
    typeof window !== "undefined" && window.REACT_APP_MOCK_DAT_RATES;
  if (windowFlag === true || windowFlag === "true") {
    return true;
  }
  return process.env.REACT_APP_MOCK_DAT_RATES === "true";
};

export const getDatRates = request => {
  if (isMockDatRatesEnabled()) {
    return Promise.resolve({ data: datRatesMockData });
  }
  return API.post("api/v1.0/Dat/rates", request);
};
